









const textVariant = {
	"light":"dark",
};

export default {
	props:{
		text:{
			type:String,
			required:true
		},
		icon:{
			type:String,
			default:"mdi.alert-outline"
		},
		theme:{
			type:String,
			default:"danger"
		}
	},
	computed:{
		textVariant(){
			return this.theme === "light" ? "dark" : "light";
		}
	}
}
